import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from 'components/TopicsOccupation/PageTitle'
import Tags from './Tags'
import TagUserSubmission from './TagUserSubmission'

const TopicsManagement = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle title={'Industry & Expertise'} />
    </div>
    <Tags />
    <TagUserSubmission />
  </div>
)

TopicsManagement.defaultProps = {
  isLoading: false,
}

TopicsManagement.propTypes = {
  isLoading: PropTypes.bool,
}

export default TopicsManagement
